<template>
	<app-icon :class="`${getCourierColor(transportType)} ${$attrs.class}`" :icon="getCourierIcon(transportType)" />
</template>
<script>
	import AppIcon from '@/components/app/AppIcon';
	import courierTypes from '@/constants/courierTypes';

	export default {
		components: { AppIcon },
		props: ['transportType'],
		methods: {
			getCourierIcon(transportType) {
				return courierTypes.find((courier) => courier.type === parseInt(transportType)).icon;
			},
			getCourierColor(transportType) {
				return courierTypes.find((courier) => courier.type === parseInt(transportType)).color;
			},
		},
	};
</script>
